module.exports = __webpack_public_path__ + "static/media/2040321000.59a8e2c1.jpg";